import React from 'react';

// Stroke-based warning-triangle line icon so it colours with the sidebar's white
// icon treatment. The old version used a grey fill (via .sidebar-icons g). Used
// by Health & Safety and Training.
const HealthSafety = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.29 3.86L1.82 18C1.47 18.6 1.47 19.34 1.82 19.94C2.16 20.55 2.8 20.92 3.5 20.92H20.5C21.2 20.92 21.84 20.55 22.18 19.94C22.53 19.34 22.53 18.6 22.18 18L13.71 3.86C13.36 3.26 12.71 2.89 12 2.89C11.29 2.89 10.64 3.26 10.29 3.86Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M12 9V13"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M12 17H12.01"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default HealthSafety;
